import { NumberBox } from "devextreme-react";
import LoadingIndicator from "../../../Component/LoadingIndicator";
import { useState } from "react";
import { useAsync, useAsyncFn } from "react-use";
import repository from "./LeaveRepository";
import { Button } from "devextreme-react/button";
const LeaveSettingForm = () => {
  const [totalAnualLeave, setAnualLeave] = useState(0);

  const state = useAsync(async () => {
    const data = await repository.getTotalAnualLeave();
    setAnualLeave(data.value);
  }, []);

  const [updateState, updateSettings] = useAsyncFn(
    async ({ totalAnualLeave }) => {
      await repository.updateSettings({
        data: { TOTAL_ANUAL_LEAVE: totalAnualLeave },
      });
    },
    []
  );

  return (
    <div>
      {state.loading || updateState.loading ? (
        <LoadingIndicator />
      ) : state.error || updateState.error ? (
        <div>
          {state.error != null
            ? state.error.message
            : updateState.error.message}
        </div>
      ) : (
        <div className="flex">
          <div>
            <div className="dx-field">
              <div className="dx-field-label">Jumlah Cuti / Tahun</div>
              <div className="dx-field-value">
                <NumberBox
                  defaultValue={totalAnualLeave}
                  onValueChanged={(e) => setAnualLeave(e.value)}
                />
              </div>
            </div>
            <div className="flex justify-end mt-4">
              <Button
                width={120}
                text="Simpan"
                type="default"
                stylingMode="contained"
                onClick={() => updateSettings({ totalAnualLeave })}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LeaveSettingForm;
